import { AstNodeCategory, AstNodeType } from './node';
export class Program {
    constructor() {
        this.nodeType = AstNodeType.Program;
        this.nodeCategory = AstNodeCategory.Program;
        this.statements = [];
    }
    get Statements() {
        return this.statements;
    }
    addStatement(stmt) {
        this.statements.push(stmt);
    }
    tokenLiteral() {
        if (this.statements.length) {
            return this.statements[0].tokenLiteral();
        }
        return '';
    }
    toString() {
        return this.statements.map((s) => s.toString()).join('\n');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvZ3JhbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXN0L1Byb2dyYW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFXLGVBQWUsRUFBRSxXQUFXLEVBQWEsTUFBTSxRQUFRLENBQUM7QUFFMUUsTUFBTSxPQUFPLE9BQU87SUFBcEI7UUFDSSxhQUFRLEdBQWdCLFdBQVcsQ0FBQyxPQUFPLENBQUM7UUFDNUMsaUJBQVksR0FBb0IsZUFBZSxDQUFDLE9BQU8sQ0FBQztRQUVoRCxlQUFVLEdBQWdCLEVBQUUsQ0FBQztJQW9CekMsQ0FBQztJQWxCRyxJQUFJLFVBQVU7UUFDVixPQUFPLElBQUksQ0FBQyxVQUFVLENBQUM7SUFDM0IsQ0FBQztJQUVNLFlBQVksQ0FBQyxJQUFJO1FBQ3BCLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9CLENBQUM7SUFFRCxZQUFZO1FBQ1IsSUFBSSxJQUFJLENBQUMsVUFBVSxDQUFDLE1BQU0sRUFBRTtZQUN4QixPQUFPLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsWUFBWSxFQUFFLENBQUM7U0FDNUM7UUFDRCxPQUFPLEVBQUUsQ0FBQztJQUNkLENBQUM7SUFFRCxRQUFRO1FBQ0osT0FBTyxJQUFJLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9ELENBQUM7Q0FDSiJ9